<template>
  <div class="referral-tokens-container">
    <earnings-list v-if="tokensMetaState"></earnings-list>

    <info-text-block v-if="referralDetails.earned || isBronzeTokenPending">
      <span v-if="referralDetails.earned" class="paragraph inner space-after-text" v-html="labels.totalEarnings"></span>
      <span v-if="isBronzeTokenPending" class="paragraph inner bronze-token-pending-text space-after-text">
        {{ labels.bronzeTokenPending }}
      </span>
      <a v-translate :href="termsLink" class="is-underlined no-wrap">Learn more</a>
    </info-text-block>
  </div>
</template>

<script>

import InfoTextBlock from 'top20common/components/text-blocks/InfoTextBlock';
import currencies from 'top20common/distribution/services/currencies';
import {mapGetters} from 'vuex';

import EarningsList from './EarningsList';

export default {
  computed: {
    ...mapGetters(['referralDetailsBySlugState', 'tokensMetaState', 'userDetailsState', 'pendingTokensState']),
    labels() {
      let earned = this.totalReferralEarnings;

      return {
        bronzeTokenPending: this.$gettextInterpolate(
          this.$gettext(
            'The Bronze Token is pending because %{name} still needs to pass our initial screening. Check back later.'
          ),
          {name: this.referralDetails.first_name}
        ),
        totalEarnings: this.$gettextInterpolate(
          this.$gettext('You have now earned a total of <strong>%{earned}</strong> from this referral.'),
          {earned}
        )
      };
    },
    referralSlug() {
      return this.$route.params.slug;
    },
    referralDetails() {
      return this.referralDetailsBySlugState[this.referralSlug] || {};
    },
    totalReferralEarnings() {
      return this.formatEarnings(this.referralDetails.earned);
    },
    isBronzeTokenPending() {
      return this.pendingTokensState.filter(
        token => token.type === 'bronze' && token.referral_id === this.referralDetails.id
      ).length;
    },
    langPrefix() {
      return this.$language.isChinese() ? '/cn' : '';
    },
    termsLink() {
      return `${this.langPrefix}/terms-and-conditions-candidate#referrals`;
    }
  },
  methods: {
    formatEarnings(value) {
      return currencies.getFormattedCurrencyFullValue(this.userDetailsState.currency, value, 0, 0);
    }
  },
  components: {
    EarningsList,
    InfoTextBlock
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.space-after-text::after {
  content: ' ';
}
.referral-tokens-container /deep/ .info-text-block {
  margin-top: 40px;
}

@media screen and (max-width: $tablet) {
  .referral-tokens-container {
    /deep/ .info-text-block {
      margin: 40px -23px 0;
    }
  }
}
</style>
